<template>
    <div class="button-card" :class="{ 'mobile': getMobileAppState }" @click.stop="emit('clicked')">
        <div class="text-wrapper">
            <!-- Card Label -->
            <div class="label">{{label}}</div>
            <!-- Card Description -->
            <div class="description">{{description}}</div>
        </div>
        <!-- Card Icon -->
        <app-icon class="icon"/>
    </div>
</template>

<script setup>
/* Vue */
import { computed, defineAsyncComponent } from 'vue'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'
/* Emmitters */
const emit = defineEmits(['clicked'])
/* mapGetters */
const { getMobileAppState } = mapGetters()

/** Props received:
@icon {String}
@label { String }
@description {  String }
*/

const props = defineProps({
    icon: String,
    label: String,
	description: String
})

/* Computed */
const appIcon = computed(() => {
	return defineAsyncComponent(() => import('@/assets/icons/illustrations/' + props.icon + '.svg?inline'))
})
</script>

<style lang="scss" scoped>
.button-card {
    width: 508px;
    max-width: 100%;
    height: 280px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;

    padding: 24px;
    border-radius: 16px;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
    background-color: var(--secondary-light-4);

    cursor: pointer;

    .text-wrapper {
        max-width: 356px;

        .label {
            @include H2-Medium;
            line-height: 36px;
            color: var(--primary);

            margin-bottom: 16px;

            &:first-letter {
                text-transform: uppercase;
            }
        }

        .description {
            @include H5-Regular;
            line-height: 20px;
            color: var(--secondary-dark-3);

            &:first-letter {
                text-transform: uppercase;
            }
        }
    }

    .icon {
        width: 136px;
        height: 136px;

        display: flex;
        align-items: center;
        align-self: flex-end;
        justify-items: center;
        flex-shrink: 0;

        :deep(.change-color) {
            stroke: var(--primary);
        }

        :deep(.change-color-fill) {
            fill: var(--secondary-light-3);
        }
    }

    @media (hover: hover) and (pointer: fine) {
        &:hover:not(.mobile) {
            background-color: var(--secondary-light-3);
        }
    }

    &:active {
        background-color: var(--secondary-light-2);

        .icon {
            :deep(.change-color-fill) {
                fill: var(--secondary-light-3);
            }
        }
    }

    // MOBILE STYLES
    &.mobile {
        width: 328px;
        height: 96px;

        flex-direction: row;
        align-items: center;

        padding: 16px;
        .text-wrapper {
            .label {
                @include H5-Medium;
                line-height: 20px;

                margin-bottom: 0;
            }

            .description {
                @include H7-Regular;
                line-height: 16px;
            }
        }

        .icon {
            width: 64px;
            height: 64px;
        }
    }
}
</style>
